import { render } from "./BillsRaisedWithNoCollectors.vue?vue&type=template&id=0bea739e&scoped=true"
import script from "./BillsRaisedWithNoCollectors.vue?vue&type=script&lang=js"
export * from "./BillsRaisedWithNoCollectors.vue?vue&type=script&lang=js"

import "./BillsRaisedWithNoCollectors.vue?vue&type=style&index=0&id=0bea739e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bea739e"]])

export default __exports__